var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00019 1.25002L6.92302 1.25001C6.37802 1.24989 6.00665 1.24981 5.68234 1.30699C4.12979 1.58075 2.91424 2.7963 2.64049 4.34884C2.5833 4.67315 2.58339 5.04452 2.58351 5.58953L2.58352 5.66669V10.3334L2.58351 10.4105C2.58339 10.9555 2.5833 11.3269 2.64049 11.6512C2.91424 13.2037 4.12979 14.4193 5.68234 14.6931C6.00664 14.7502 6.37801 14.7502 6.92302 14.75L7.00019 14.75H7.33352C7.74773 14.75 8.08352 14.4142 8.08352 14C8.08352 13.5858 7.74773 13.25 7.33352 13.25H7.00019C6.34887 13.25 6.12038 13.2472 5.94281 13.2158C5.01128 13.0516 4.28195 12.3223 4.1177 11.3907C4.08639 11.2132 4.08352 10.9847 4.08352 10.3334V5.66669C4.08352 5.01538 4.08639 4.78688 4.1177 4.60931C4.28195 3.67779 5.01128 2.94846 5.94281 2.7842C6.12038 2.75289 6.34887 2.75002 7.00019 2.75002H7.33352C7.74773 2.75002 8.08352 2.41424 8.08352 2.00002C8.08352 1.58581 7.74773 1.25002 7.33352 1.25002H7.00019ZM11.1972 4.80303C10.9043 4.51013 10.4294 4.51013 10.1365 4.80303C9.84363 5.09592 9.84363 5.57079 10.1365 5.86369L11.5229 7.25002H7.33352C6.9193 7.25002 6.58352 7.58581 6.58352 8.00002C6.58352 8.41424 6.9193 8.75002 7.33352 8.75002H11.5229L10.1365 10.1364C9.84363 10.4293 9.84363 10.9041 10.1365 11.197C10.4294 11.4899 10.9043 11.4899 11.1972 11.197L13.8638 8.53035C14.1567 8.23746 14.1567 7.76259 13.8638 7.46969L11.1972 4.80303Z",
    fill: "#EB5B5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut2);
export default __webpack_public_path__ + "static/media/Log-out2.5b60ba275d83ade595d2383ac0fe0369.svg";
export { ForwardRef as ReactComponent };